
import  Header  from './Header.jsx'
import  TopNavbar  from './TopNavbar.jsx'

{/*import  Hero  from './Hero.jsx'*/}
import { Outlet } from 'react-router-dom'
import  LoginPopup  from './LoginPopup.jsx'


import Footer from '../footer/footer.jsx'






/*import { BgImage } from '/ucla.jpg'*/
const Layout = () => {
   {/*const [loginPopup, setLoginPopup] = useState(true);
const toggleLoginPopup = () => { setLoginPopup((prev) => !prev); }*/}




    return (
<div className="relative min-h-screen">
   {/*<div className={loginPopup ? "" : ""}>
<Header toggleLoginPopup={toggleLoginPopup} /> 
<Hero toggleLoginPopup={toggleLoginPopup}  />
<LoginPopup toggleLoginPopup={toggleLoginPopup} loginPopup={loginPopup} />
</div>*/}

<Header />
<TopNavbar />








<main className='pb-52'>
    <Outlet/>    

</main>
<Footer />
</div>

)
}

export default Layout;
/*const bgImage = {
    backgroundImage: `url(${BgImage})`,
    backgroundPosition: 'center',
    backgroundSize: "cover",
    backgroundRepeat: 'no-repeat',
    height: '100vh',
    width: '100%'
  };*/